<template>
  <div class="auth-card">
    <div class="ac-head">
      <el-icon :size="22" color="#b06000"><Lock /></el-icon>
      <div>
        <div class="ac-title">信息上报后台需要登录</div>
        <div class="ac-sub">巡检模块已免登录；如需查看「上报信息」，请输入电脑端信息收集后台的账号密码</div>
      </div>
    </div>
    <div class="ac-form">
      <input v-model="username" class="ac-input" placeholder="账号（默认 admin）" autocomplete="username" />
      <input v-model="password" type="password" class="ac-input" placeholder="密码" autocomplete="current-password" @keyup.enter="login" />
      <el-button type="primary" :loading="busy" style="width:100%;height:42px" @click="login">登录并加载</el-button>
      <p v-if="err" class="ac-err">{{ err }}</p>
      <p class="ac-skip" @click="$emit('skip')">暂不查看（跳过）</p>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { loginGather, setGatherToken, setUserName } from '../api'

const emit = defineEmits(['authed', 'skip'])
const username = ref('admin')
const password = ref('')
const busy = ref(false)
const err = ref('')

async function login() {
  const u = username.value.trim()
  if (!u || !password.value) { err.value = '请输入账号和密码'; return }
  busy.value = true
  err.value = ''
  try {
    const r = await loginGather({ username: u, password: password.value })
    setGatherToken(r.token)
    setUserName(u)
    emit('authed')
  } catch (e) {
    err.value = e.message || '登录失败'
  } finally {
    busy.value = false
  }
}
</script>

<style scoped>
.auth-card { background: #fff; border-radius: 14px; padding: 16px; box-shadow: 0 3px 12px rgba(31,45,61,.06); margin-bottom: 10px; }
.ac-head { display: flex; align-items: flex-start; gap: 10px; margin-bottom: 12px; }
.ac-title { font-size: 15px; font-weight: 700; color: #202124; }
.ac-sub { font-size: 12px; color: #9aa0a6; margin-top: 3px; line-height: 1.6; }
.ac-form { display: flex; flex-direction: column; gap: 8px; }
.ac-input {
  border: 1px solid #d5d9de; border-radius: 10px; padding: 10px 12px;
  font-size: 14px; outline: none; background: #fff; width: 100%;
}
.ac-input:focus { border-color: #1a73e8; }
.ac-err { color: #c5221f; font-size: 12.5px; }
.ac-skip { text-align: center; color: #1a73e8; font-size: 12.5px; cursor: pointer; margin: 2px 0; }
</style>
